import { ENDPOINTS } from '@/lib/constants/endpoints'
import { httpClient } from '@/providers/httpClient'
import type { IUser, IUserRole } from '@/types/user'
import type { IServiceError } from '@/types/error'

export async function list(): Promise<IUser[] | IServiceError> {
  return httpClient.get<IUser[]>(ENDPOINTS.PEOPLE.USERS.LIST)
}

export async function create(user: { email: string; name: string; role: string }): Promise<IServiceError | void> {
  return httpClient.post<void>(ENDPOINTS.PEOPLE.USERS.CREATE, user)
}

export async function deleteUser(userId: string): Promise<IServiceError | void> {
  return httpClient.delete<void>(ENDPOINTS.PEOPLE.USERS.DELETE(userId))
}

export async function deleteUsers(userIds: string[]): Promise<IServiceError | void> {
  if (userIds.length === 0) return
  return httpClient.post<void>(ENDPOINTS.PEOPLE.USERS.BULK_DELETE, { userIds })
}

export async function updateRole(userId: string, role: IUserRole): Promise<IServiceError | void> {
  return httpClient.patch<void>(ENDPOINTS.PEOPLE.USERS.UPDATE_ROLE(userId), { role })
}

export async function createBulk(filesData: FormData): Promise<IServiceError | void> {
  return httpClient.post<void>(ENDPOINTS.PEOPLE.EMPLOYEES.BULK_UPLOAD, filesData)
}

export async function parseCsv(filesData: FormData): Promise<
  | {
      users: { name: string; email: string; trainingStatus: string }[]
      errors: { line: number; column: string; message: string }[]
    }
  | IServiceError
> {
  return httpClient.post(ENDPOINTS.PEOPLE.USERS.PARSE_CSV, filesData)
}

export async function switchTenant(tenantId: number): Promise<IServiceError | void> {
  return httpClient.post<void>(ENDPOINTS.PEOPLE.USERS.SWITCH_TENANT, { tenantId })
}
